import React from 'react';
import { motion } from 'framer-motion';
interface SegmentedControlProps {
  options: string[];
  selected: string;
  onChange: (option: string) => void;
}
export function SegmentedControl({
  options,
  selected,
  onChange
}: SegmentedControlProps) {
  return <div className="bg-sand rounded-ios p-1 flex gap-1" data-id="element-444">
      {options.map(option => <button key={option} onClick={() => onChange(option)} className="relative flex-1 px-4 py-2 text-sm font-medium transition-colors rounded-ios" data-id="element-445">
          {selected === option && <motion.div layoutId="segmentedControlBg" className="absolute inset-0 bg-white rounded-ios shadow-ios" transition={{
        type: 'spring',
        stiffness: 500,
        damping: 30
      }} data-id="element-446" />}
          <span className={`relative z-10 ${selected === option ? 'text-dark-green' : 'text-moss-gray'}`} data-id="element-447">
            {option}
          </span>
        </button>)}
    </div>;
}